import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Customer} from "../customer";
import {CustomerService} from "../customer-service.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent implements OnInit {

  customers: Customer[];
  id: String
  myError: string;

  constructor(private customerService: CustomerService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.myError = "";
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params['id'];

    if (this.id) {
      this.customerService.delete(this.id, this).subscribe(result => this.gotoCustomerList(), error => this.myError= "Customer not found");
    } else {
      this.customerService.findAll().subscribe(data => this.customers = data, error => this.myError= "Customers not found");
    }
  }

  gotoCustomerList() {
    this.router.navigate(['/customers']);
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-list/customer-list.component.ts